import React, { useRef, useEffect } from 'react';
import BScroll from '@better-scroll/core';
import { reportClick } from '@/utils/report';
import { jumpToPageByH5 } from '@/utils/fn';
import { DISTRIBUTION_MAP } from '../../const';
import styles from './index.less';

const ActIncomeInfo = ({ type = 'group', pageName, distribution, setModalStatus }) => {
  const bsScrollContainer = useRef(null);

  const handleIncomeItemClick = (type = 'invite') => {
    reportClick({
      page_name: pageName,
      button_name: `${type}_reward_btn`,
    });
    switch (type) {
      case 'online':
        jumpToPageByH5('/reward/online?origin=daily');
        break;
      case 'x86':
        jumpToPageByH5('/invite/x86/inviter?origin=daily');
        break;
      case 'invite':
        jumpToPageByH5('/invite/inviter?origin=daily');
        break;
      case 'contribution':
        setModalStatus(true, type);
        break;
      case 'activity':
        setModalStatus(true, type);
        break;
      default:
        setModalStatus(true, type);
        break;
    }
  };

  useEffect(() => {
    let bsScroll;
    if (distribution?.length > 0 && bsScrollContainer.current) {
      bsScroll = new BScroll(bsScrollContainer.current, {
        scrollX: true,
        click: true,
        eventPassthrough: 'vertical',
      });
    }
    return () => bsScroll?.destroy();
  }, [distribution]);

  return (
    // <div className={`${styles['ubox']} ${styles['act-reward']}`}>
    <div>
      <div className={styles.actIncome}>
        <p>收益分布</p>
      </div>
      <div className={styles.rewardListWrapper} ref={bsScrollContainer}>
        {distribution && distribution.length > 0 && (
          <ul className={styles.actRewardList}>
            {distribution.map((item, idx) => (
              <li
                className={
                  DISTRIBUTION_MAP[item.is].ename === 'invite' ||
                  DISTRIBUTION_MAP[item.is].ename === 'x86' ||
                  DISTRIBUTION_MAP[item.is].ename === 'online'
                    ? styles.withTip
                    : ''
                }
                key={idx}
                onClick={() => handleIncomeItemClick(DISTRIBUTION_MAP[item.is].ename)}
              >
                <i className={`${styles.icon} ${styles[DISTRIBUTION_MAP[item.is].ename]}`} />
                <h4 className={styles.rewardTitle}>{DISTRIBUTION_MAP[item.is].name}</h4>
                {item?.c > 0 && (
                  <p className={styles.rewardVal}>
                    {item.c}
                    <span className={styles.valUnit}>元</span>
                  </p>
                )}
                <p className={styles.rewardVal}>
                  {item.cbv}
                  {item.cbu}
                  <span className={styles.valUnit}>云豆</span>
                </p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
export default ActIncomeInfo;
